<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :center="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :z-index="16000011"
    :close-dialog-tooltip="bp('closeDialogToolTip')"
    @close="close"
  >
    <template slot="title">
      <span class="el-dialog__title heading heading--md" qaid="modalSectionHeader">{{ title }}</span>
    </template>

    <div>
      <p class="text-left mb-3" qaid="modalHelperText">
        {{ body }}
      </p>

      <div class="b2b-scroll-list-container w-full">
        <div class="b2b-scroll-list">
          <table class="b2b-grid">
            <thead class="b2b-grid__header">
              <tr>
                <th class="b2b-grid__cell b2b-grid__head" qaid="skuColumn">
                  {{ bp('advancedOrderSku') }}
                </th>
                <th class="b2b-grid__cell b2b-grid__head" qaid="descColumn">
                  {{ bp('advancedOrderName') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in nonAOItems" :key="index" :qaid="`dataRow${index}`">
                <td class="b2b-grid__cell table-cell">
                  {{ item.sku }}
                </td>
                <td class="b2b-grid__cell table-cell">
                  {{ item.itemName }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <template slot="footer">
      <div class="buttons buttons--center">
        <trek-button v-if="!displayAddErrorModal" primary @click="redirectToCart">
          <span v-html="bp('advancedOrderCart')"></span>
        </trek-button>
        <trek-button secondary qaid="backButton" @click="close">
          <span v-html="bp('advancedOrderClose')"></span>
        </trek-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import TrekButton from '@/components/TrekButton';
import ElDialog from '@/components/Dialog';

export default {
  components: {ElDialog, TrekButton},

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dialogVisible: false,
    };
  },

  computed: {
    title() {
      if (this.displayAddErrorModal) {
        // When the user tries to add a non-AO product to cart in AO mode:
        // Sorry, these SKU(s) cannot be added to your cart.
        return this.bp('advancedOrderCannotAdd');
      } else if (this.advancedOrderingMode) {
        // When AO only products are in cart and user tries to toggle AO:
        // Advanced ordering cannot be turned off
        return this.bp('advancedOrderOffCannot');
      } else {
        // When the user has non-AO products in cart and tries to toggle AO switch:
        // Advanced ordering cannot be turned on
        return this.bp('advancedOrderTitle');
      }
    },

    body() {
      if (this.displayAddErrorModal) {
        // When the user tries to add a non-AO product to cart in AO mode
        return this.bp('advancedOrderNotAvailable');
      } else if (this.advancedOrderingMode) {
        // When AO only products are in cart and user tries to toggle AO
        return this.bp('advancedOrderOffCannotSku');
      } else {
        // When the user has non-AO products in cart and tries to toggle AO switch
        return this.bp('advancedOrderBody');
      }
    },

    ...mapState('backend', ['encodedContextPath']),
    ...mapState('advancedOrdering', [
      'nonAOItems',
      'advancedOrderingError',
      'advancedOrderingMode',
      'displayAddErrorModal',
    ]),
  },

  watch: {
    nonAOItems(value) {
      if (value && value.length) this.dialogVisible = true;
      else this.close();
    },

    advancedOrderingError(value) {
      if (value) {
        this.$notify.closeAll();

        this.$notify({
          type: 'alert',
          message: this.advancedOrderingMode ? this.bp('advancedOrderOffWrong') : this.bp('advancedOrderUnable'),
          showClose: true,
          duration: 0,
        });

        this.setAdvancedOrderingError(false);
      }
    },
  },

  methods: {
    redirectToCart() {
      window.location = `${this.encodedContextPath}/cart`;
    },

    close() {
      this.setDisplayAddErrorModal(false);
      this.dialogVisible = false;
    },

    ...mapMutations('advancedOrdering', ['setAdvancedOrderingError', 'setDisplayAddErrorModal']),
  },
};
</script>
